import { EntityService } from '../../service/EntityService';
import { PaymentSummaryCounts } from './lich-su-thanh-toan/constants';

const normalizePaymentLogParams = (  params: Record<string, unknown>,
): Record<string, unknown> => {
  const normalized = { ...params };
  const sourceType = normalized.sourceType;

  if (sourceType === null || sourceType === undefined) {
    delete normalized.sourceType;
    return normalized;
  }

  if (Array.isArray(sourceType)) {
    normalized.sourceType = sourceType
      .map((item) => String(item).trim())
      .filter((item) => item.length > 0);
    return normalized;
  }

  if (typeof sourceType === 'string' && sourceType.length > 0) {
    normalized.sourceType = sourceType
      .split(',')
      .map((item) => item.trim())
      .filter((item) => item.length > 0);
    return normalized;
  }

  delete normalized.sourceType;
  return normalized;
};

const serializePaymentLogParams = (
  params: Record<string, unknown>,
): string => {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value === null || value === undefined) {
      return;
    }

    if (Array.isArray(value)) {
      value.forEach((item) => {
        if (item !== null && item !== undefined && item !== '') {
          searchParams.append(key, String(item));
        }
      });
      return;
    }

    searchParams.append(key, String(value));
  });

  return searchParams.toString();
};

const buildPaymentLogUrl = (
  path: string,
  params: Record<string, unknown>,
): string => {
  const queryString = serializePaymentLogParams(normalizePaymentLogParams(params));
  return queryString ? `${path}?${queryString}` : path;
};

export class PaymentLogService extends EntityService {

  static entity = 'app/payment-log';

  static getList(params: Record<string, unknown>): Promise<any> {
    return this.axios
      .get(buildPaymentLogUrl(this.entity, params))
      .then((res) => res.data);
  }

  static downloadExcel(params: Record<string, unknown>): Promise<any> {
    return this.axios
      .get(buildPaymentLogUrl(`${this.entity}/file-excel`, params), {
        responseType: 'blob',
      })
      .then((res) => res.data);
  }

  static getSummary(params: Record<string, unknown>): Promise<PaymentSummaryCounts> {
    return this.axios
      .get(buildPaymentLogUrl(this.entity, params))
      .then((res) => res.data);
  }

}
